import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "LongarrowUp"
});
const _hoisted_1 = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.03809 4.07766L4.79398 0.703704C4.91079 0.598768 5.08894 0.598765 5.20575 0.703696L8.9619 4.07762C9.08729 4.19024 9.09675 4.38221 8.98304 4.5064L8.96185 4.52739V4.52739L8.4427 4.99349C8.3259 5.09835 8.14783 5.09835 8.03104 4.99349L5.76505 2.95902L5.7661 9.07144C5.76617 9.22046 5.65778 9.34442 5.51481 9.37015L5.45967 9.375V9.375L4.54024 9.375C4.37098 9.37498 4.23377 9.23908 4.23374 9.07144L4.23327 2.95902L1.96868 4.99337C1.85187 5.09831 1.67372 5.09831 1.5569 4.99338L1.0381 4.52737C0.912713 4.41475 0.903249 4.22277 1.01696 4.09859L1.03809 4.07766V4.07766Z",
  fill: "#0FBD81"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var longarrowUp = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { longarrowUp as default };
